import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialog, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { FormErrors, isValidMailFormat } from 'app/shared/validators/generic-validators';

import { User } from 'app/shared/models/user.model';

import { AuthenticationGuard } from 'app/services/authentication-guard.service';
import { UserService } from './../user.service';

@Component({
    selector: 'user',
    templateUrl: './user.component.html'
})
/**
 * Component to add and update User details.
 */
export class UserComponent implements OnInit {
    savingUser: boolean;
    selectedUser: User;
    arrUserRole: any[] = [];
    userStatuses: any[] = [];
    userForm: FormGroup;
    isAdmin: boolean;
    action = 'Add';
    userStatus: boolean = false;
    userId: number;
    loginId: string;
    name: string;
    email: string;
    userRole: string;

    formErrors = {
        'loginId': '',
        'name': '',
        'email': '',
        'userRole': '',
    };

    validationMessages = {
        'loginId': {
            'required': 'Required field value.',
        },
        'name': {
            'required': 'Required field value.',
        },
        'email': {
            'required': 'Required field value.',
            'invalidEmail': 'Invalid email format.',
        },
        'userRole': {
            'required': 'Required field value.',
        },
    };

    constructor(
        private authenticationGuard: AuthenticationGuard,
        public dialogRef: MdDialogRef<any>,
        private formBuilder: FormBuilder,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService,
        private userService: UserService
    ) { }

    createForm() {
        this.userForm = this.formBuilder.group({
            loginId: ['', Validators.required],
            name: ['', Validators.required],
            email: ['', Validators.compose([
                Validators.required, isValidMailFormat
            ])],
            userRole: ['', Validators.required],
            userStatus: [''],
        });
        this.userForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    ngOnInit() {
        this.createForm();
        this.setUpUserRoles([]);
        this.setUpUserStatus([]);
        this.updateUserForm();
        this.action = this.dialogRef.componentInstance.action;
        this.isAdmin = this.authenticationGuard.isAdminUser();
    }

    onValueChanged(data?: any) {
        if (!this.userForm) {
            return;
        }
        FormErrors('userForm', this);
    }

    // @todo temp solution.
    onResetUserPassword() {
        if (this.loginId && confirm(MessageService.RESET_USER_PASSWORD_ALERT)) {
            this.userService.getPasswordReset(this.loginId)
                .subscribe(response => {
                    if (response.flagResult && response.message !== '') {
                        alert(response.message);
                    }
                },
                    err => {
                        if (err.message) {
                            alert(err.message);
                        }
                    }
                );
        }
    }

    onSubmit({ value, valid }) {
        // @todo: add check to whether submitter has the right role to change roles.

        const params = {
            userId: this.userId,
            loginId: value.loginId,
            name: value.name,
            email: value.email,
            userRole: value.userRole,
            disabled: value.userStatus,
        };

        this.savingUser = true;
        this.userService.saveUser(params, this.dialogRef.componentInstance.action)
            .subscribe(success => {
                this.savingUser = false;
                if (this.action === 'Edit') {
                    this.snackBarService.showStatus(success, '', '');
                } else if (success.message && success.message !== '') {
                    // @todo temp solution.
                    alert(success.message);
                }
                this.trackingService
                    .emitEvent(
                        TrackingConstants.USER_MANAGEMENT,
                        TrackingConstants.SAVE_USER,
                        TrackingConstants.SUCCESS, 1);
                if (success.flagResult) {
                    this.dialogRef.close(params);
                }
            },
                err => {
                    this.savingUser = false;
                    this.trackingService
                        .emitEvent(
                            TrackingConstants.USER_MANAGEMENT,
                            TrackingConstants.SAVE_USER,
                            TrackingConstants.FAILURE, 0);
                    this.snackBarService.showStatus(err, '', MessageService.USER_UPDATE_FAILURE);
                }
            );
    }

    // @todo: This function will be modified to get user role from REST.
    setUpUserRoles(dropDownValues: any) {
        this.arrUserRole = [
            { 'id': 1, 'value': 'READ' },
            { 'id': 2, 'value': 'USER' },
            { 'id': 3, 'value': 'ADMIN' },
            { 'id': 4, 'value': 'SYSTEM' },
            { 'id': 5, 'value': 'DNB' }
        ];
    }
    setUpUserStatus(dropDownValues: any) {
        this.userStatuses = [
            { 'value': false },
            { 'value': true }
        ];
    }

    updateUserForm(): void {
        if (this.selectedUser) {
            for (let inner in this.userForm.controls) {
                this.userForm.get(inner).markAsTouched();
                this.userForm.get(inner).updateValueAndValidity();
            }
            this.loginId = this.selectedUser.loginId;
            this.name = this.selectedUser.name;
            this.email = this.selectedUser.email;
            this.userId = this.selectedUser.userId;
            this.userRole = this.selectedUser.userRole;
            this.userStatus = this.selectedUser.disabled;
            this.userForm.patchValue(this.selectedUser);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user/user.component.ts